import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { TagText } from '../../internal/internal-typography';
import tagTheme from './theme';

type Props = {
  /**
   * Text to be rendered in the tag.
   */
  text: string,
};

const TagContainer = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
  background: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  display: inline-block;
  height: 20px;
  left: 20px;
  top: 20px;
`;

const TagStyledText = styled(TagText)`
  color: ${(props) => props.theme.fontColor};
`;

const Ellipsified = styled.div`
  max-width: 150px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.theme.fontColor};
`;

const Tag = (props: Props) => {
  return (
    <ThemeProvider theme={props.theme}>
      <TagContainer title={props.text}>
        <Ellipsified>
          <TagStyledText>{props.text}</TagStyledText>
        </Ellipsified>
      </TagContainer>
    </ThemeProvider>
  );
};

const PrimaryTag = (props: Props) => (
  <Tag {...props} theme={tagTheme.important} />
);

const SecondaryTag = (props: Props) => (
  <Tag {...props} theme={tagTheme.status} />
);

const NeutralTag = (props: Props) => (
  <Tag {...props} theme={tagTheme.private} />
);

export { PrimaryTag, SecondaryTag, NeutralTag };
